import { useDispatch } from 'react-redux';
import { useIntl } from "react-intl";

//Components
import { MenuItem, ListItemIcon, ListItemText, Menu } from '@mui/material';

import {
    dashboardPanelCreateEditOpenModal,
    dashboardPanelDeleteOpenModal,
    dashboardPanelShareOpenModal,
} from 'Redux/actions';

//Icons
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import ShareIcon from '@mui/icons-material/Share';

const MenuActions = (props) => {
    const { anchorDashboard, setAnchorDashboard, dashboards, dashboardSelected } = props
    const { messages } = useIntl();
    const dispatch = useDispatch();

    let actions = [
        {
            label: messages['menu_actions_rename_dashboard'],
            show: true,
            icon: <EditIcon fontSize="small" />,
            action: () => {
                dispatch(dashboardPanelCreateEditOpenModal(true, dashboardSelected));
                setAnchorDashboard(null);
            }
        },
        {
            label: messages['menu_actions_delete_dashboard'],
            show: dashboards.filter((item) => !item?.shared).length > 1 && (!dashboardSelected?.shared),
            icon: <DeleteIcon fontSize="small" />,
            action: () => {
                dispatch(dashboardPanelDeleteOpenModal(true, dashboardSelected));
                setAnchorDashboard(null);
            }
        },
        {
            label: messages['menu_actions_share'],
            show: (!dashboardSelected?.shared),
            icon: <ShareIcon fontSize="small" />,
            action: () => {
                dispatch(dashboardPanelShareOpenModal(true, dashboardSelected))
                setAnchorDashboard(null);
            }
        }
    ]

    return (
        <Menu
            elevation={0}
            anchorEl={anchorDashboard}
            open={Boolean(anchorDashboard)}
            onClose={() => setAnchorDashboard(null)}
            className="menu-user"
            getcontentanchorel={null}
            anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            transformOrigin={{ vertical: 'center', horizontal: 'left' }}
        >
            {
                actions.map((item, index) => {
                    if (item.show) {
                        return (
                            <MenuItem
                                onClick={(c) => item.action()}
                                key={index + 1}
                            >
                                <ListItemIcon>
                                    {item.icon}
                                </ListItemIcon>
                                <ListItemText primary={item.label} className="listMenuItem" />
                            </MenuItem>
                        )
                    }
                })
            }
        </Menu>
    )
}

export default MenuActions